ModelCache = require 'db/model-cache'
rpc = require 'network/rpc'
assert = require 'lib/assert'
_ = require 'underscore'

assocAt = (root, keyPath, newValue) ->
  assert keyPath.length >= 1
  [key, remainingKeys...] = keyPath

  newObj = if root? then _.clone(root) else {}
  newObj[key] = if remainingKeys.length == 0
    newValue
  else
    assocAt newObj[key], remainingKeys, newValue

  return newObj

normalizeId = (delta) ->
  if !delta._id?
    return delta
  delta = _.clone(delta)
  delta.id ?= delta._id
  delete delta._id
  delta

rpc.on 'updateModels', ({ typeName, deltas }) ->
  for delta in deltas.map(normalizeId)
    ModelCache.enqueueRpcDelta(typeName, delta)
  return

rpc.on 'deleteModels', ({ typeName, deltas }) ->
  for { id } in deltas.map(normalizeId)
    ModelCache.enqueueRpcDelta(typeName, { id, deleted: true })
  return



// WEBPACK FOOTER //
// ./app/scripts/init/live-updater.coffee